/**
 * The picture library: everything in it is the administrator's (admin portal,
 * Picture library - apps/api/src/library.ts), the occasion drawings too since
 * 2026-10-11 ("i want these ones included in the admin section so i can
 * delete or add to them"). The drawings were made for FoldMyCard as vector
 * files; their sources are kept in library-drawings/ at the top of the
 * repository (drawings.json says which group each went into), and they were
 * added to the library as 1600 px pictures - the size a drawing became when
 * someone picked it anyway (local/store.ts addFromLibrary).
 *
 * The groups are shown with the occasions first, in the order below, and any
 * other group after them, alphabetically.
 */

/** `url`: the picture itself; `thumb`: a small copy for the list, when there is one. */
export interface LibraryItem { id: string; name: string; url: string; thumb?: string }
export interface LibraryGroup { id: string; name: string; items: LibraryItem[] }

/** The occasions: first in the editor, and offered first when adding to the library. */
export const OCCASION_GROUPS = ['Birthday', 'Love & wedding', 'Winter & holidays', 'Festivals', 'Milestones', 'Nature'];

/** The library's pictures (api.library), in their groups. */
export function libraryGroups(items: { id: string; group: string; name: string; urls: { preview: string; thumb: string } }[]): LibraryGroup[] {
  const groups = new Map<string, LibraryGroup>();
  for (const p of items) {
    const key = p.group.toLowerCase();
    if (!groups.has(key)) groups.set(key, { id: `group-${key}`, name: p.group, items: [] });
    // `photo-` as before: a picture already taken from the library is found again by this id
    groups.get(key)!.items.push({ id: `photo-${p.id}`, name: p.name, url: p.urls.preview, thumb: p.urls.thumb });
  }
  const rank = (name: string) => {
    const i = OCCASION_GROUPS.findIndex((o) => o.toLowerCase() === name.toLowerCase());
    return i < 0 ? OCCASION_GROUPS.length : i;
  };
  return [...groups.values()].sort((a, b) => rank(a.name) - rank(b.name) || a.name.localeCompare(b.name));
}
